module.exports = "canvas {\n  width: 150px !important;\n  height: 150px !important; }\n\n.chart {\n  position: relative;\n  width: 150px !important;\n  height: 150px !important; }\n\n.percentage {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  margin-top: -100px;\n  font-size: 35px;\n  font-weight: 300;\n  text-align: center;\n  color: #176193; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/diagram-round/diagram-round.component.scss
// module id = ./src/app/shared/components/diagram-round/diagram-round.component.scss
// module chunks = main